import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import * as eventKeys from '../lib/events';

export default (el, props) => {
    const OFFSET_BUFFER = 5;
    const OFFSET_TOP = 100;

    const $el = $(el);
    const $bar = $el.find('[data-header-bar]');
    const $menuToggle = $el.find('[data-menu-toggle]');
    const $menuToggleSpans = $menuToggle.find('span');

    let scrollingLocked = false;
    let preventShow = false;
    let lastTop = Viewport.scroll.top;
    let headerShowing = true;
    let informationPanelHeight = 0;
    let line1top = 0;
    let line3top = 0;


    const onLockMenuBar = () => {
        scrollingLocked = true;
    };

    const onUnlockMenuBar = () => {
        scrollingLocked = false;
    };

    const show = () => {
        if (headerShowing) {
            return;
        }
        headerShowing = true;
        TweenLite.to($bar.nodes, 0.5, {
            yPercent: 0,
            ease: 'Quint.easeOut',
            onComplete: () => Dispatch.emit(eventKeys.HEADER_AFTER_SHOW)
        });
        Dispatch.emit(eventKeys.HEADER_BEFORE_SHOW);
    };

    const hide = forced => {
        if (!headerShowing) {
            return;
        }
        headerShowing = false;
        TweenLite.to($bar.nodes, forced ? 0 : 0.1, {
            yPercent: -100,
            ease: 'Quad.easeIn',
            onComplete: () => Dispatch.emit(eventKeys.HEADER_AFTER_HIDE)
        });
        Dispatch.emit(eventKeys.HEADER_BEFORE_HIDE);
    };

    const onMenuOpen = (key, data) => {
        if ($menuToggleSpans.length >= 3) {
            const $line1 = $($menuToggleSpans.get(0));
            const $line2 = $($menuToggleSpans.get(1));
            const $line3 = $($menuToggleSpans.get(2));

            line1top = $line1.position().top;
            line3top = $line3.position().top;

            TweenLite.to([$line1.get(0), $line3.get(0)], 0.1, {
                top: $line2.position().top, ease: Sine.easeIn, onComplete: () => {
                    $line2.css({ opacity: 0 });
                    TweenLite.to($line1.get(0), 0.5, { rotation: -45, ease: Quint.easeOut });
                    TweenLite.to($line3.get(0), 0.5, { rotation: 45, ease: Quint.easeOut });
                }
            });

        }
    };

    const onMenuClose = (key, data) => {
        if ($menuToggleSpans.length >= 3) {
            const $line1 = $($menuToggleSpans.get(0));
            const $line2 = $($menuToggleSpans.get(1));
            const $line3 = $($menuToggleSpans.get(2));

            TweenLite.to([$line1.get(0), $line3.get(0)], 0.2, {
                rotation: 0, ease: Sine.easeIn, onComplete: () => {
                    $line2.css({ opacity: 1 });
                    TweenLite.to($line1.get(0), 0.5, { top: line1top, ease: Quint.easeOut });
                    TweenLite.to($line3.get(0), 0.5, { top: line3top, ease: Quint.easeOut });
                }
            });

        }
    };

    const onInformationPanelUpdate = (key, data) => {
        informationPanelHeight = data.height;
    };

    const onScroll = () => {
        const top = Viewport.scroll.top;

        if (!scrollingLocked) {

            if (Math.abs(top - lastTop) > OFFSET_BUFFER) {
                const isScrollingUp = top < lastTop;
                if (isScrollingUp) {
                    if (!preventShow) {
                        show();
                    }
                } else if (top > (OFFSET_TOP + informationPanelHeight)) {
                    hide();
                }
            }
        }

        lastTop = top;
    };

    const onResize = e => {
        e.preventDefault();
    };

    const onBreakpoint = e => {
        e.preventDefault();
    };

    const onProgrammaticScrollStart = () => {
        preventShow = true;
        hide();
    };

    const onProgrammaticScrollEnd = () => {
        preventShow = false;
    };

    const init = () => {

        $el.addClass('js-header-enabled');

        $el.on('click', '[data-infopanel-toggle]', () => {
            Dispatch.emit(eventKeys.INFORMATION_PANEL_VISIBLE);
        });

        $menuToggle.on('click', e => {
            e.preventDefault();
            Dispatch.emit(eventKeys.MENU_TOGGLE);
        });

        /*
        $bar.css({ display: 'block' });
        TweenLite.set($bar.nodes, { yPercent: $html.hasClass('scrolled') ? -100 : 0 });
        headerShowing = !$html.hasClass('scrolled');
        */

        TweenLite.set($bar.nodes, { yPercent: 0 });
        headerShowing = true;

        Dispatch.on(eventKeys.LOCK_MENU_BAR, onLockMenuBar, true);
        Dispatch.on(eventKeys.UNLOCK_MENU_BAR, onUnlockMenuBar, true);
        Dispatch.on(eventKeys.INFORMATION_PANEL_UPDATE, onInformationPanelUpdate, true);

        Dispatch.on(eventKeys.PROGRAMMATIC_SCROLL_START, onProgrammaticScrollStart);
        Dispatch.on(eventKeys.PROGRAMMATIC_SCROLL_END, onProgrammaticScrollEnd);

        Dispatch.on(eventKeys.MENU_OPEN, onMenuOpen, true);
        Dispatch.on(eventKeys.MENU_CLOSE, onMenuClose, true);

        Viewport.on('scroll', onScroll);
        Viewport.on('breakpoint', onBreakpoint);
        Viewport.on('resize', onResize);
    };

    const destroy = () => {
        $el.off('click');
        $menuToggle.off('click');

        Dispatch.off(eventKeys.LOCK_MENU_BAR, onLockMenuBar);
        Dispatch.off(eventKeys.UNLOCK_MENU_BAR, onUnlockMenuBar);
        Dispatch.off(eventKeys.INFORMATION_PANEL_UPDATE, onInformationPanelUpdate);

        Dispatch.off(eventKeys.PROGRAMMATIC_SCROLL_START, onProgrammaticScrollStart);
        Dispatch.off(eventKeys.PROGRAMMATIC_SCROLL_END, onProgrammaticScrollEnd);

        Dispatch.off(eventKeys.MENU_OPEN, onMenuOpen);
        Dispatch.off(eventKeys.MENU_CLOSE, onMenuClose);

        Viewport.off('scroll', onScroll);
        Viewport.off('breakpoint', onBreakpoint);
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
